import { Flex } from '@applyboard/crystal-ui';
import { queryParameterContext } from '../context';

import { PageHeader } from '../../../components/PageHeader';
import {
  ProgramsPagination,
  ProgramsTable,
  ProgramLevelFilter,
  QueryFilter,
  FieldOfStudyFilter,
  Sort,
} from '../components';

export function TabletLayout() {
  return (
    <Flex p={6} gap={6} direction="column">
      <PageHeader title="Program Catalog" />
      <Filter as={<QueryFilter />} width="100%" />
      <Flex gap={2}>
        <Filter as={<ProgramLevelFilter />} width="25%" />
        <Filter as={<FieldOfStudyFilter />} width="25%" />
        <Filter as={<Sort />} width="25%" />
      </Flex>
      <Flex pt={2}>
        <queryParameterContext.FilterSummary />
      </Flex>
      <ProgramsTable />
      <ProgramsPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
